import React, { useEffect } from 'react';
import cls from '@utils/css-select';
import styles from './styles.scss';
import FromTable from './component/form-table';
// import SceneBox from './component/scene-box';
// import TechBlock from './component/tech-block';
// import GradeBlock from './component/grade-block';
// import PlanBox from './component/plan-box';
// import ClassroomBox from './component/classroom-box';
// import AppraisalBox from './component/appraisal-box';
// import AboutUs from './component/about-us';
// import FeatureBox from './component/feature-box';
import PageContainer from 'containers/en/page-container';
const cx = cls(styles);

export default function EnLandingHome() {

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [])
	return (
		<PageContainer  className={`en ${cx('en-landing-container')}`}>
			<FromTable />
			{/* <SceneBox />
			<TechBlock />
			<GradeBlock />
			<PlanBox />
			<ClassroomBox />
			<AppraisalBox />
			<AboutUs />
			<FeatureBox /> */}
		</PageContainer>
	);
}
